import notificationTypes from './notification.types';

export const getNotificationStatusAction = (payload, cb, cbError) => ({
  type: notificationTypes.UPDATE_NOTIFICATION_STATUS,
  payload,
  cb,
  cbError
});
